import { MethodEnum } from '@enum/method.enum';
import { isString } from '@util/data/is-exist';

export const goTemplate = (
  link: string,
  headers: Record<string, string> = {},
  body: Record<string, string> = {},
  method: MethodEnum = MethodEnum.GET,
) => {
  const headersText = Object.entries(headers)
    .filter(([, value]) => isString(value))
    .map(([key, value]) => `  req.Header.Add("${key}", "${value}")`);

  return `package main

import (
  "fmt"
  "net/http"
  "io/ioutil"
)

func main() {
  url := "${encodeURI(link)}"
  method := "${method}"

  payload := strings.NewReader(\`${JSON.stringify(body)}\`)

  client := &http.Client {}
  req, err := http.NewRequest(method, url, payload)

  if err != nil {
    fmt.Println(err)
    return
  }

${headersText.join('\n')}

  res, err := client.Do(req)
  if err != nil {
    fmt.Println(err)
    return
  }
  defer res.Body.Close()

  body, err := ioutil.ReadAll(res.Body)
  if err != nil {
    fmt.Println(err)
    return
  }
  fmt.Println(string(body))
}`;
};
